<div class="d-flex flex-column gap-24 k-py-4">
  <div class="grid-scroll-wrapper">
    <kendo-grid
      class="no-hover"
      [data]="gridData$ | async"
      scrollable="none"
      [pageable]="false"
      [group]="hasMultipleSections() ? groupDescriptors : []"
      [selectable]="{ mode: 'multiple', checkboxOnly: true }"
      [kendoGridSelectBy]="selectBy"
      [(selectedKeys)]="selectedKeys">

      <ng-template kendoGridGroupHeaderTemplate let-value="value">
        {{ value }}
      </ng-template>

      <kendo-grid-checkbox-column [showSelectAll]="true"></kendo-grid-checkbox-column>

      <kendo-grid-column field="lineItem.articleNumber" title="{{ 'ARTICLE' | translate }} / {{ 'SUPPLIER' | translate }}" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="k-d-flex k-flex-column k-py-1">
            <span class="colors-neutral-800 k-font-semibold">{{ dataItem.lineItem.articleNumber }}</span>
            <span class="colors-neutral-600">{{ dataItem.lineItem.supplierName }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="lineItem.description" #wrapper title="{{ 'DESCRIPTION' | translate }}" [width]="300">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div rcSelectableOverflow [placement]="'top'" [wrapperElement]="wrapper" [trigger]="'hover'">
            {{ dataItem.lineItem.description || '-' }}
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="correctAmount" title="{{ 'CORRECT_AMOUNT' | translate }}" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-numerictextbox
            [(ngModel)]="dataItem.correctAmount"
            [ngModelOptions]="{ standalone: true }"
            [min]="0"
            [decimals]="amountDecimals"
            [format]="amountFormat"
          ></kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="correctPurchasePrice" title="{{ 'CORRECT_PURCHASE_PRICE' | translate }}" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-numerictextbox
            [(ngModel)]="dataItem.correctPurchasePrice"
            [ngModelOptions]="{ standalone: true }"
            [min]="0"
            [format]="decimalFormat"
            [decimals]="2"
          ></kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="note" title="{{ 'NOTE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-textarea
            [(ngModel)]="dataItem.note"
            [ngModelOptions]="{ standalone: true }"
            [rows]="2"
          ></kendo-textarea>
        </ng-template>
      </kendo-grid-column>

    </kendo-grid>
  </div>

  <div class="d-flex flex-column gap-1">
    <kendo-label
      labelCssClass="k-form-label"
      [for]="description"
      [text]="'DESCRIPTION' | translate | capitalize"></kendo-label>
    <kendo-textarea
      [(ngModel)]="description"
      [ngModelOptions]="{ standalone: true }"
      [rows]="3"
    ></kendo-textarea>
  </div>
</div>

<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button kendoButton class="g-start-10" [iconClass]="'rc-icon-check'" (click)="createSupplierComplaint()" [disabled]="selectedKeys.length === 0">
      {{ "GENERATE" | translate | capitalize }}
    </button>
    <button class="g-col-2 g-start-11" kendoButton [iconClass]="'rc-icon-send'" [themeColor]="'primary'" (click)="createAndSendSupplierComplaint()" [disabled]="selectedKeys.length === 0">
      {{ "GENERATE_AND_SEND" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
